import React from 'react';
import { onDark, onLight } from './BrandAssets';

// Ported from the plugin's Brand.jsx. Using the same embedded base64 logos
// here purely for guaranteed visual parity with the plugin's output — this
// app almost certainly already has the real Aptclouds logo as a proper
// asset/import somewhere (this was a plugin-only workaround for having no
// static file server). Swap `onDark`/`onLight` below for your real asset
// imports if you'd rather not carry the base64 blobs in this codebase.
export function Brand({ light = false, height = 30 }) {
  const src = light ? onDark : onLight;
  return (
    <span className="brand">
      <img src={src} alt="Aptclouds" style={{ height, width: 'auto', display: 'block' }} />
    </span>
  );
}

export default Brand;